module.exports = __webpack_public_path__ + "static/media/Banner-Controle-720x180-TelaValores.752b464c.png";